import React from 'react';
import { TrendingUpIcon, UsersIcon, TagIcon, DollarSignIcon, ClockIcon } from 'lucide-react';
import Card from '../../components/ui/Card';
import Table from '../../components/ui/Table';
import StatusBadge from '../../components/ui/StatusBadge';
const CampaignDashboard: React.FC = () => {
  // Mock data
  const activeCampaigns = [{
    id: 'CMP-2023-001',
    name: 'Summer Sale 2023',
    utilization: 45,
    transactions: 1250,
    discountGiven: 2450000,
    daysLeft: 12
  }, {
    id: 'CMP-2023-003',
    name: 'Tech Week Bonanza',
    utilization: 12,
    transactions: 450,
    discountGiven: 120000,
    daysLeft: 5
  }];
  const columns = [{
    header: 'Campaign',
    accessor: 'name'
  }, {
    header: 'Transactions',
    accessor: 'transactions'
  }, {
    header: 'Discount Given',
    accessor: (row: any) => `PKR ${row.discountGiven.toLocaleString()}`
  }, {
    header: 'Utilization',
    accessor: (row: any) => <div className="w-24" data-id="element-2531">
          <div className="flex justify-between text-xs mb-1" data-id="element-2532">
            <span data-id="element-2533">{row.utilization}%</span>
          </div>
          <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-1.5" data-id="element-2534">
            <div className="bg-blue-500 h-1.5 rounded-full" style={{
          width: `${row.utilization}%`
        }} data-id="element-2535"></div>
          </div>
        </div>
  }, {
    header: 'Time Left',
    accessor: (row: any) => <span className={row.daysLeft < 7 ? 'text-red-500 font-medium' : 'text-gray-500'} data-id="element-2536">
          {row.daysLeft} days
        </span>
  }];
  return <div className="space-y-6" data-id="element-2537">
      <div data-id="element-2538">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-2539">
          Campaign Dashboard
        </h1>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400" data-id="element-2540">
          Real-time monitoring of active discount campaigns
        </p>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-2541">
        <Card className="bg-blue-50 dark:bg-blue-900/20 border-blue-100 dark:border-blue-800" data-id="element-2542">
          <div className="flex items-center" data-id="element-2543">
            <div className="p-3 rounded-full bg-blue-500 text-white mr-4" data-id="element-2544">
              <TagIcon className="h-6 w-6" data-id="element-2545" />
            </div>
            <div data-id="element-2546">
              <p className="text-sm font-medium text-blue-600 dark:text-blue-400" data-id="element-2547">
                Active Campaigns
              </p>
              <p className="text-2xl font-bold text-blue-900 dark:text-blue-100" data-id="element-2548">
                5
              </p>
            </div>
          </div>
        </Card>
        <Card className="bg-green-50 dark:bg-green-900/20 border-green-100 dark:border-green-800" data-id="element-2549">
          <div className="flex items-center" data-id="element-2550">
            <div className="p-3 rounded-full bg-green-500 text-white mr-4" data-id="element-2551">
              <DollarSignIcon className="h-6 w-6" data-id="element-2552" />
            </div>
            <div data-id="element-2553">
              <p className="text-sm font-medium text-green-600 dark:text-green-400" data-id="element-2554">
                Total Discount Given
              </p>
              <p className="text-2xl font-bold text-green-900 dark:text-green-100" data-id="element-2555">
                PKR 4.2M
              </p>
            </div>
          </div>
        </Card>
        <Card className="bg-purple-50 dark:bg-purple-900/20 border-purple-100 dark:border-purple-800" data-id="element-2556">
          <div className="flex items-center" data-id="element-2557">
            <div className="p-3 rounded-full bg-purple-500 text-white mr-4" data-id="element-2558">
              <TrendingUpIcon className="h-6 w-6" data-id="element-2559" />
            </div>
            <div data-id="element-2560">
              <p className="text-sm font-medium text-purple-600 dark:text-purple-400" data-id="element-2561">
                Transactions Impacted
              </p>
              <p className="text-2xl font-bold text-purple-900 dark:text-purple-100" data-id="element-2562">
                12,450
              </p>
            </div>
          </div>
        </Card>
        <Card className="bg-orange-50 dark:bg-orange-900/20 border-orange-100 dark:border-orange-800" data-id="element-2563">
          <div className="flex items-center" data-id="element-2564">
            <div className="p-3 rounded-full bg-orange-500 text-white mr-4" data-id="element-2565">
              <UsersIcon className="h-6 w-6" data-id="element-2566" />
            </div>
            <div data-id="element-2567">
              <p className="text-sm font-medium text-orange-600 dark:text-orange-400" data-id="element-2568">
                Unique Customers
              </p>
              <p className="text-2xl font-bold text-orange-900 dark:text-orange-100" data-id="element-2569">
                8,920
              </p>
            </div>
          </div>
        </Card>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-2570">
        <div className="lg:col-span-2" data-id="element-2571">
          <Card title="Live Campaign Performance" data-id="element-2572">
            <Table columns={columns} data={activeCampaigns} keyField="id" pagination={false} data-id="element-2573" />
          </Card>
        </div>
        <div data-id="element-2574">
          <Card title="Expiring Soon" data-id="element-2575">
            <div className="space-y-4" data-id="element-2576">
              <div className="flex items-center justify-between p-3 bg-yellow-50 dark:bg-yellow-900/20 rounded-md border border-yellow-100 dark:border-yellow-800" data-id="element-2577">
                <div className="flex items-center" data-id="element-2578">
                  <ClockIcon className="h-5 w-5 text-yellow-600 mr-3" data-id="element-2579" />
                  <div data-id="element-2580">
                    <p className="font-medium text-sm text-gray-900 dark:text-white" data-id="element-2581">
                      Tech Week Bonanza
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-2582">Expires in 5 days</p>
                  </div>
                </div>
                <StatusBadge status="warning" text="Expiring" data-id="element-2583" />
              </div>
              <div className="flex items-center justify-between p-3 bg-red-50 dark:bg-red-900/20 rounded-md border border-red-100 dark:border-red-800" data-id="element-2584">
                <div className="flex items-center" data-id="element-2585">
                  <ClockIcon className="h-5 w-5 text-red-600 mr-3" data-id="element-2586" />
                  <div data-id="element-2587">
                    <p className="font-medium text-sm text-gray-900 dark:text-white" data-id="element-2588">
                      Flash Sale
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-2589">Expires in 12 hours</p>
                  </div>
                </div>
                <StatusBadge status="danger" text="Urgent" data-id="element-2590" />
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>;
};
export default CampaignDashboard;